import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { getAllMenuItems, type MenuItem } from "@/config/routes";
import { hasPhoneMatch } from "@/utils/phone";

export const useMenu = (onOpenChange: (open: boolean) => void) => {
  const navigate = useNavigate();
  const { logout: authLogout, userName, userPhone } = useAuth();

  const handleLogout = () => {
    authLogout();
    navigate("/login");
    onOpenChange(false);
    toast.success("Вы вышли из аккаунта");
  };

  // Filter menu items based on phone number
  const allMenuItems = getAllMenuItems();
  const menuItems: MenuItem[] = allMenuItems.filter(
    (item) => !item.showForPhone || hasPhoneMatch(item.showForPhone, userPhone)
  );

  return {
    menuItems,
    handleLogout,
    userName,
  };
};
